import React from "react";
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
export default class OfficeOverheadItem
{
  constructor (item)
  {
    if (item === undefined)
    {
      this.Quarter = "";
      this.OfficeOverheadId = "";
      this.OfficeId = "";
      this.PricingOverheadRate = "";
      this.ActualOverheadRate = "";
    } else
    {
      this.OfficeOverheadId = item.officeOverheadId;
      this.OfficeId = item.officeId;
      this.Quarter = item.quarter;
      this.PricingOverheadRate = item.pricingOverheadRate === null ? "" : item.pricingOverheadRate.toString();
      this.ActualOverheadRate = item.actualOverheadRate === null ? "" : item.actualOverheadRate.toString();
    }
  }

  static ToString (item)
  {
    let officeOverheadItem = new OfficeOverheadItem();
    officeOverheadItem.Quarter = item.Quarter === null ? "" : item.Quarter.toString();
    officeOverheadItem.OfficeOverheadId = item.OfficeOverheadId === null ? "" : item.OfficeOverheadId.toString();
    officeOverheadItem.OfficeId = item.OfficeId === null ? "" : item.OfficeId.toString();
    officeOverheadItem.PricingOverheadRate = item.PricingOverheadRate === null ? "" : item.PricingOverheadRate.toString();
    officeOverheadItem.ActualOverheadRate = item.ActualOverheadRate === null ? "" : item.ActualOverheadRate.toString();
    return officeOverheadItem;
  }

  static FieldsToShowInDataTable ()
  {
    return [
      { label: "Quarter", orderById: "", data: (item) => item.Quarter },
      { label: "Pricing Overhead Rate", orderById: "", data: (item) => item.PricingOverheadRate + " %", className: "text-left" },
      { label: "Actual Overhead Rate", orderById: "", data: (item) => item.ActualOverheadRate + " %", className: "text-left" },
      { label: " ", orderById: "", data: OfficeOverheadItem.getActionCellContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static getActionCellContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            text: "Edit",
            onClick: () => OfficeOverheadItem.clickOnEdit(item),
            iconName: "fa-solid fa-edit",
            roleKey: "office_overhead_edit",
          },
          {
            text: "Remove",
            onClick: () => OfficeOverheadItem.clickOnRemove(item),
            iconName: "fa-regular fa-trash-can",
            roleKey: "OfficeOverheadPanelDelete",
          },
        ]}
      />
    );
  }
}
